import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useMergeDraftOrders = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "draftordermerge",
        command: data.ordersToMerge,
        data: JSON.stringify(data.data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orderListState"] });
    },
  });
};

const response = {
  status: 200,
  statusText: "OK",
  data: {
    data: {
      data: {
        filter: {
          noFilter: null,
          staffLineNo: null,
          Approvals: null,
        },
        order: {
          no: "DF88447",
          poNo: null,
          status: "Open",
          branch: null,
          requestedShippingDate: null,
          code: "ADDR54291",
          contact: "Oli",
          name: null,
          address: "140 Gordon Road",
          address2: null,
          city: "Birmingham",
          county: "West Midlands",
          postCode: "B17 9EY",
          country: "GB",
          homeaddress: "No",
          email: "support@peterdrew.com",
          mobileNo: "017897747779",
          orderTotal: "7.4",
          awaitingApproval: "No",
        },
        staff: [
          {
            no: "STA102701",
            staffLineNo: "10000",
            name: "Oli Drew",
            gender: "M",
            yourId: "789789",
            branch: "Branch 1 Scotland",
            branchid: "B001",
            uniformId: "WARDROBE00025",
            uniform: "Standard Wardrobe",
            contract: "TEST77",
            contractName: "test77",
            numberOfLines: "0",
            exceeded: "No",
            reasonCode: null,
            reasonDescription: null,
            staffpoNo: "TEST77",
            blocked: "No",
            contractBlocked: "No",
          },
          {
            no: "STA152889",
            staffLineNo: "20000",
            name: "Jevgenijs Jemeljanovs",
            gender: "M",
            yourId: "WEARER1",
            branch: "Branch 1 Scotland",
            branchid: "B001",
            uniformId: "WARDROBE00817",
            uniform: "Uneek - Polos",
            contract: "002",
            contractName: "Contract 2",
            numberOfLines: "0",
            exceeded: "No",
            reasonCode: null,
            reasonDescription: null,
            staffpoNo: null,
            blocked: "No",
            contractBlocked: "No",
          },
        ],
      },
    },
  },
};
